import { render, staticRenderFns } from "./LouverWoods.vue?vue&type=template&id=717cd048&scoped=true&"
import script from "./LouverWoods.vue?vue&type=script&lang=js&"
export * from "./LouverWoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717cd048",
  null
  
)

export default component.exports